/* eslint-disable @typescript-eslint/no-empty-function */
// 公共message提示框
import { MessagePlugin, MessageInfoOptions } from 'tdesign-vue';
import { formatError } from '@/renderer/scripts/utils/errorCode/index';
type RequestError = {
  code: string;
  message: string;
  status: number;
};
export type MsgError = string | RequestError;
interface Tips {
  info: (message: string | MessageInfoOptions, duration?: number | undefined) => void;
  success: (message: string | MessageInfoOptions, duration?: number | undefined) => void;
  warning: (message: string | MessageInfoOptions, duration?: number | undefined) => void;
  loading: (message: string | MessageInfoOptions, duration?: number | undefined) => void;
  error: (message: MsgError | MessageInfoOptions, flag?: boolean | number, fallbackMessage?: string) => void;
  closeAll: () => void;
}
type TipMethod = 'loading' | 'info' | 'success' | 'error' | 'warning';
const types: TipMethod[] = ['loading', 'info', 'success', 'error', 'warning'];
const tips: Tips | {} = {};
types.forEach((type: TipMethod) => {
  if (type === 'error') return;
  (tips as Tips)[type] = (message: string | MessageInfoOptions, duration = 2000) => {
    MessagePlugin.closeAll();
    return MessagePlugin[type](message, duration);
  };
});
(tips as Tips).error = (
  message: MsgError | MessageInfoOptions,
  flag?: boolean | number | any,
  fallbackMessage?: string,
) => {
  let disableLogger = false;
  let duration = 2000;
  if (typeof flag === 'boolean') disableLogger = flag;
  else if (typeof flag === 'number') duration = flag;
  MessagePlugin.closeAll();
  if ((message as MessageInfoOptions).content) {
    MessagePlugin.error(message as MessageInfoOptions, duration);
  } else {
    // 如果是取消导致的错误，则不做任何提示
    if (typeof message !== 'string' && (message as RequestError).message === 'canceled') return;
    const errMessage = formatError(message as MsgError, disableLogger, fallbackMessage);
    // 服务到期tips提示
    if (['OrganizationServiceTimeExpired', 'LibraryServiceTimeExpired'].includes((message as RequestError).code)) {
      return;
    }
    MessagePlugin.error(errMessage, duration);
  }
};
(tips as Tips).closeAll = MessagePlugin.closeAll;
export default tips as Tips;
